// Auto-generated skeleton for PersonUpdateRequest

import { Person } from "./Person";
import { User } from "./User";

export const PersonUpdateRequest: Api.PersonUpdateRequest = {
  id: 0,
  person: Person,
  person_id: 0,
  current_data: null,
  updated_data: null,
  reason: '',
  comment: null,
  synced_at: null,
  approved_at: null,
  rejected_at: null,
  user_processed_id: 0,
  user_processed: User,
  created: null,
  updated: null,
};

